import React, { useEffect, useState, useRef } from "react";
import './index.css';
import { useLocation } from "react-router-dom";
import axios from 'axios';
import io from 'socket.io-client';
import Button from '@mui/material/Button';
import './GearTracker.css'
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom'
import PlayerCardv2 from "./components/PlayerCardv2";
import Snackbar from '@mui/material/Snackbar';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import LootTable from "./components/LootTable";
import TableChartIcon from '@mui/icons-material/TableChart';
import Banner from './Media/banner.png';
import Solver from './components/Solver'
import CalculateIcon from '@mui/icons-material/Calculate';
import Collapse from '@mui/material/Collapse';
import LinearProgress from '@mui/material/LinearProgress';
import ExportSheet from './components/ExportSheet'
import ImportExportIcon from '@mui/icons-material/ImportExport';

function GearTracker() {

    const navigate = useNavigate();

    const [data, setData] = useState({
        players: [],
        static: {},
        fetched: false,
        playersCopy: [],
        fetchingGearset: false,
        copiedNotification: false,
        saved: false,
        requestFailed: false,
        vertical: 'bottom',
        horizontal: 'center',
        menu: 'none',
    });

    const dataRef = useRef(data);
    const { vertical, horizontal, copiedNotification, saved, requestFailed } = data;
    var socket;

    let location = useLocation();
    async function getPlayers(path) {
        let url = process.env.REACT_APP_API_URL + path
        try {
            await axios.get(url).then(response => {
                response.data.players.map((player) => {
                    player['modified'] = false;
                    player['updatePending'] = false;
                    if (player.role === 'tank')
                        player['color'] = '#4557a6'
                    else if (player.role === 'healer')
                        player['color'] = '#45773b'
                    else if (player.role === 'dps')
                        player['color'] = '#813b3c'
                    else {
                        player['color'] = '#5f5f5f'
                    }
                })
                setData({ ...data, players: response.data.players, static: response.data.static, fetched: true, playersCopy: structuredClone(response.data.players) });
            })
        }
        catch (e) {
            console.log(e);
            if (e.status == 404) {
                navigate('/StaticNotFound')
            }
        }
    }

    function getBackupPlayerByID(ID) {
        var player = {}
        data.playersCopy.some((selectedPlayer) => {
            if (ID == selectedPlayer.playerID) {
                player = selectedPlayer;
                return true;
            }
        })
        return player;
    }

    function modifyPlayer(player) {
        var sortedPlayers = data.players.sort(function (a, b) { return a.playerID - b.playerID });
        player['modified'] = true;
        sortedPlayers[player.playerID] = player;
        setData({ ...data, players: sortedPlayers })
    }

    function undoChanges(player) {
        var sortedPlayers = data.players.sort(function (a, b) { return a.playerID - b.playerID });
        var backupPlayer = structuredClone(getBackupPlayerByID(player.playerID))
        sortedPlayers[player.playerID] = backupPlayer;
        setData({ ...data, players: sortedPlayers });
        document.getElementById(`playerName${player.playerID}`).value = backupPlayer.name;
        document.getElementById(`etroLink${player.playerID}`).value = backupPlayer.etroLink;
    }

    function generatePlayerCards() {
        var playerCards =
            <section class="layout">
                {data.players.map((player) =>
                    <div key={`${player.playerID}-id`}>
                        <PlayerCardv2 player={player} etroFailed={etroFailed} modifyPlayer={modifyPlayer} updatePlayer={updatePlayer} undoChanges={undoChanges} saveMissing={saveMissing}></PlayerCardv2>
                    </div>)}
            </section>
        return playerCards;
    }

    async function updatePlayer(player) {
        delete player.modified;
        delete player.updatePending;
        try {
            let url = process.env.REACT_APP_API_URL + location.pathname + '/update'
            await axios.post(url, {
                data: {
                    from: data.socketid,
                    player: player
                }
            }).then((res) => {
                var sortedPlayers = data.players.sort(function (a, b) { return a.playerID - b.playerID });
                sortedPlayers[player.playerID]['modified'] = false;
                data.playersCopy[player.playerID] = structuredClone(player);
                setData({ ...data, players: sortedPlayers, playersCopy: structuredClone(data.playersCopy), saved: true });
            })
        }
        catch (e) {
            console.log(e)
            setData({ ...data, requestFailed: true })
        }

    }

    async function joinRoom(path) {
        socket.emit('join_room', {
            path: path
        })
    }

    function incomingUpdate(player) {
        var sortedPlayers = dataRef.current.players.sort(function (a, b) { return a.playerID - b.playerID });
        sortedPlayers[player.playerID] = player;
        sortedPlayers[player.playerID]['modified'] = false;
        dataRef.current.players = sortedPlayers;
        setData({ ...dataRef.current });
        document.getElementById(`playerName${player.playerID}`).value = player.name;
        //document.getElementById(`etroLink${player.playerID}`).value = player.etroLink;
    }

    function keyPressStaticName(e) {
        if (e.key == 'Enter') {
            var staticName = e.target.value;
            var _static = structuredClone(data.static);
            _static.name = staticName;
            if (_static.name == data.static.name)
                return;
            updateStatic(_static)
        }
    }

    function onBlurStaticName(e) {
        var staticName = e.target.value;
        var _static = structuredClone(data.static);
        _static.name = staticName;
        if (_static.name == data.static.name)
            return;
        updateStatic(_static)
    }

    async function updateStatic(_static) {
        try {
            let url = process.env.REACT_APP_API_URL + `/gearing/${data.static._id}/updatestatic`
            await axios.post(url, {
                data: {
                    from: data.socketid,
                    static: _static
                }
            }).then((res) => {
                setData({ ...data, static: _static, saved: true });
                document.getElementById('staticName').blur();
            })
        }
        catch (e) {
            console.log(e)
            setData({ ...data, requestFailed: true })
        }

    }

    function incomingUpdateStatic(_static) {
        dataRef.current.static = _static;
        setData({ ...dataRef.current });
        document.getElementById('staticName').value = _static.name;
    }

    function handleCopy(e) {
        e.preventDefault()
        navigator.clipboard.writeText(window.location.href)
        setData({ ...data, copiedNotification: true })
    }

    function handleClose() {
        setData({ ...data, copiedNotification: false, requestFailed: false, saved: false })
    }

    function etroFailed() {
        setData({ ...data, requestFailed: true })
    }

    function saveMissing(player) {
        var sortedPlayers = data.players.sort(function (a, b) { return a.playerID - b.playerID });
        sortedPlayers[player.playerID] = player;
        setData({ ...data, players: sortedPlayers })
    }

    function toggleMenu(menu) {
        if (data.menu == menu)
            setData({ ...data, menu: 'none' })
        else {
            setData({ ...data, menu: menu })
        }
    }
    function closeMenu() {
        setData({ ...data, menu: 'none' })
    }

    useEffect(() => {
        dataRef.current = data;
    }, [data]);

    useEffect(() => {
        socket = io.connect(process.env.REACT_APP_API_URL)
        socket.on('connect', () => {
            setData({ ...dataRef.current, socketid: socket.id })
        })
        getPlayers(location.pathname);
        joinRoom(location.pathname.split('/')[2])

        // Listen for incoming messages from the server
        socket.on("receive_message", (data) => {
            console.log(data); // Log the received message data to the console
            if (data.type == 'updatePlayer') {
                incomingUpdate(data.player)
            }
            if (data.type == 'updateStatic') {
                incomingUpdateStatic(data.static)
            }
        });
        return () => {
            socket.off('receive_message')
            socket.disconnect();
        }
    }, [])

    return (
        <div style={{ margin: '50px', marginTop: '0px', maxWidth: '100vw' }}>
            {data.static.name ? <title>{data.static.name}</title> : <title>Gearing</title>}
            {data.fetched ? (
                <div>
                    <div className='banner' style={{
                        backgroundImage: `url(${Banner})`, backgroundSize: '100vw', backgroundRepeat: 'no-repeat', position: "absolute",
                        height: '141px', width: '100%', left: 0, zIndex: -4, top: 0, borderBottom: '1px solid #c2ab6d',
                    }}>
                    </div>
                    <div className='menu' style={{
                        backgroundColor: '#37373a', position: "absolute", height: '221px',
                        width: '100%', left: 0, zIndex: -5, top: 0, borderBottom: '1px solid #c2ab6d', zIndex: -5,
                    }}> </div>

                    <div style={{ justifyContent: 'center', display: 'flex' }}>
                        <div className='banner-wrapper'>
                            <div className='banner-wrapper-inner'>
                                <div style={{ textAlign: "center", margin: '15px', position: 'relative', marginTop: '0px' }}>
                                    <TextField
                                        id='staticName' variant="standard" type="text" name="etroLink" defaultValue={data.static.name}
                                        sx={{ input: { color: 'aliceblue', borderBottom: "2px solid #ffffff", textAlign: 'center', fontSize: '24px' }, label: { color: 'aliceblue' }, width: '128ch' }}
                                        slotProps={{ htmlInput: { maxLength: 64 } }} onKeyDown={(e) => keyPressStaticName(e)} onBlur={onBlurStaticName}
                                    />
                                </div>
                                <div style={{ textAlign: "center", whiteSpace: 'nowrap' }}>
                                    Copy this url to save and share:
                                    <div>
                                        <a class="link" href="" onClick={handleCopy}>{window.location.href}
                                            <ContentCopyIcon style={{ color: 'white', marginLeft: '10px' }} />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='menu-wrapper'>
                        <div className='btn-wrapper' style={{ background: `${data.menu == 'table' ? 'rgba(133, 133, 133, 0.596)' : 'none'}` }}>
                            <Button className='menu-btn-1' variant="contained" onClick={() => toggleMenu('table')}><TableChartIcon style={{ color: '#fad99a' }} /></Button>
                            <div className='menu-text'>Loot Table</div>
                        </div>
                        <div className='btn-wrapper' style={{ background: `${data.menu == 'calc' ? 'rgba(133, 133, 133, 0.596)' : 'none'}` }}>
                            <Button className='menu-btn-2' variant="contained" onClick={() => toggleMenu('calc')}><CalculateIcon style={{ color: '#fad99a' }} /></Button>
                            <div className='menu-text'>Solver</div>
                        </div>
                        <div className='btn-wrapper' style={{ background: `${data.menu == 'exportSheet' ? 'rgba(133, 133, 133, 0.596)' : 'none'}` }}>
                            <Button className='menu-btn-3' variant="contained" onClick={() => toggleMenu('exportSheet')}><ImportExportIcon style={{ color: '#fad99a' }} /></Button>
                            <div className='menu-text'>Import/Export</div>
                        </div>
                    </div>
                    <Collapse in={data.menu === 'table'}><LootTable players={data.players} closeMenu={closeMenu} /></Collapse>
                    <Collapse in={data.menu === 'calc'}> <Solver players={data.players} closeMenu={closeMenu} static={data.static} updateStatic={updateStatic} menu={data.menu} /> </Collapse>
                    <Collapse in={data.menu === 'exportSheet'}> <ExportSheet players={data.players} closeMenu={closeMenu} static={data.static} /> </Collapse>
                    <div style={{ position: 'relative' }}> {generatePlayerCards()} </div>
                    <Snackbar
                        anchorOrigin={{ vertical, horizontal }}
                        open={copiedNotification}
                        autoHideDuration={2000}
                        onClose={handleClose}
                        message={
                            <div><CheckCircleIcon style={{ width: '20px', color: '#56d36a' }} /><div style={{ float: "right", margin: '5px' }}>URL Copied.</div></div>
                        }
                    />

                    <Snackbar
                        anchorOrigin={{ vertical, horizontal }}
                        open={saved}
                        autoHideDuration={2000}
                        onClose={handleClose}
                        message={
                            <div><CheckCircleIcon style={{ width: '20px', color: '#56d36a' }} /><div style={{ float: "right", margin: '5px' }}>Saved.</div></div>
                        }
                    />

                    <Snackbar
                        anchorOrigin={{ vertical, horizontal }}
                        open={requestFailed}
                        autoHideDuration={2000}
                        onClose={handleClose}
                        message={
                            <div><CancelIcon style={{ width: '20px', color: '#d35f56' }} /><div style={{ float: "right", margin: '5px' }}>Request Failed.</div></div>
                        }
                    />
                </div>
            ) : <div style={{ fontFamily: 'Noto Sans', display: 'flex', justifyContent: 'center' }}>
                <div style={{ marginTop: '40vh' }}>
                    <div style={{ fontSize: '64px' }}>
                        Loading Static...
                    </div>
                    <LinearProgress sx={{ marginTop: "10px", maxWidth: "100ch" }} />
                </div>
            </div>}
        </div>
    );
}

export default GearTracker;